<template>
  <form v-on:submit.prevent="submitForm">

    <h2>Merchandise Hierarchies</h2>
    <div class="form-group"><label for="id">ID :</label><input class="form-control" id="id" readonly="readonly" v-model="merchandiseHierarchy.id"/></div>
    <div class="form-group"><label for="name">Name : </label><input class="form-control" id="name" v-model="merchandiseHierarchy.name"/></div>
    <div class="form-group"><label for="comment">Comment : </label><input class="form-control" id="comment" v-model="merchandiseHierarchy.comment"/></div>
    <div class="form-group"><label for="scope">Scope : </label><input class="form-control" id="scope" v-model="merchandiseHierarchy.scope"/></div>
    <div class="form-group"><label for="itemType">Item Type : </label><input class="form-control" id="itemType" v-model="merchandiseHierarchy.expectedItemType"/></div>
    <div class="form-group"><label for="notNormallyStockedFlag"> NotNormallyStockedFlag  </label>
      <input id="true" type="radio" value="true" v-model="merchandiseHierarchy.expectedNotNormallyStockedFlag"/> <label for="true">True</label>
      <input id="false" type="radio" value="false" v-model="merchandiseHierarchy.expectedNotNormallyStockedFlag"/> <label for="false">False</label></div>
    <div class="form-group"><label for="itemId">Item Id : </label><input class="form-control" id="itemId" type="number" v-model="merchandiseHierarchy.expectedItemID"/></div>
    <div>
      <p>
        <input class="btn btn-edit" type="submit" value="Submit">
      </p>

      <router-link class="btn btn-cancel" v-bind:to="{path: 'merchandise-hierarchies'}">
        <v-icon>mdi-cancel</v-icon>
        <input class="btn" type="submit" value="Cancel">
      </router-link>
    </div>
  </form>
</template>

<script>
import {parameters} from "../../parameters";
import {httpClient} from "../../requesters/httpClient";

export default {
  name: 'EditMerchandiseHierarchy',

  async created() {
    await httpClient.get(`${parameters.posdataRefUrl}/itemCategory/` + this.$route.query.id)
      .then((response)=> {
        this.merchandiseHierarchy = response.data;
      })
      .catch((error)=> {
        throw error;
      });
  },
  data() {
    return {
      merchandiseHierarchy: []
    }
  },
  methods: {
    async submitForm(e) {
      if (!this.nameFieldEmpty()) {
        await httpClient.put(`${parameters.posdataRefUrl}/itemCategory`, this.merchandiseHierarchy);

        await this.$alert("The merchandise hierarchy is updated");

        await this.$router.push('merchandise-hierarchies');

        e.preventDefault();
      } else {
        await this.$alert("Name field is empty")
      }
    },
    nameFieldEmpty: function(){
      if (this.merchandiseHierarchy.name === ''){
        return true;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/merchandiseHierarchies/EditMerchandiseHierarchy.vue